import { OptimizelyContext } from '@optimizely/react-sdk';
import { FunctionComponent, useContext, useEffect } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { Production } from '../../config/Config';
import { observer } from 'mobx-react';

export const Optimizely: FunctionComponent = observer(() => {
  const { UserStore, GroupStore } = useContext(AppContext);
  const { optimizely } = useContext(OptimizelyContext);

  useEffect(() => {
    if (
      UserStore.isAuthenticated &&
      UserStore.user != null &&
      GroupStore.initialLoadCompleted
    ) {
      optimizely.setUser({
        id: `${Production ? 'prd' : 'dev'}-${UserStore.user.id}`,
        attributes: {
          emailDomain: UserStore.user.email.split('@')?.[1],
          // Opti can't handle a list of items, so quote everything
          // and join with a comma
          groups: [...GroupStore.groups.values()]
            .map(g => `"${g.name}"`)
            .join(','),
        },
      });
    }
  }, [
    UserStore.isAuthenticated,
    UserStore.user,
    GroupStore.initialLoadCompleted,
  ]);

  return null;
});
